import { PageHeader } from "@how/ui";
import { CommunicationsTabs } from "./CommunicationsTabs";
import { EmailSendersCard } from "./EmailSendersCard";

/**
 * Communications → Email senders (#402): who the church's emails appear to come from, and where replies go. It lived on
 * Settings, which only the owner opens, so a communications manager could pick a sender in a campaign but not add,
 * confirm or remove one, although the database lets anyone with communications.send do so. Reading needs
 * communications.read (the route); changing needs communications.send (the card).
 */
export function SendersPage() {
  return (
    <>
      <PageHeader
        title="Communications"
        description="Who the church can reach, what it says, and what it has sent."
      />
      <CommunicationsTabs active="senders" />
      <EmailSendersCard />
    </>
  );
}
